import React from 'react';
import AddDeceased from './AddDeceased';

export default function EditDeceased(props) {
  return <AddDeceased {...props} isEditing />;
}
